import { Route, Routes } from 'react-router-dom';
import DynamicFlow from './DynamicFlow.tsx';
import CreateMap from './Create.tsx';
import TestCreatorPage from '../Test/TestCreatorPage.tsx';
import DoubtAssistantPage from '../Test/ConceptBuilder/DoubtAssistantPage.tsx';
import StudentPerformanceMap from './StudentPerformanceMap.tsx';
import StudentDashboard from '../Test/StudentDashboard.tsx';
import QuestionBankGenerator from '../Test/QuestionGenrate/Questionbankgenerator.tsx';
import CompleteTeacherDashboard from '../Test/CompleteTeacherDashboard.tsx';
import KnowledgeMapManager from './kmap/KnowledgeMapManager.tsx';
import CurriculumPipeline from './kmap/CurriculumPipeline.tsx';
import WeekWiseStudyPlan from './kmap/WeekWiseStudyPlan.tsx';
import InteractiveClassroom from './kmap/InteractiveClassroom.tsx';
import TeacherGuidelines from './kmap/TeacherGuidelines.tsx';
import StudentDashboardComponent from './kmap/StudentDashboard.tsx';
import MainDashboard from './kmap/MainDashboard.tsx';
import PerformanceMapViewer from './PerformanceMapViewer.tsx';

const Performance = () => {
  return (
    <Routes>
      <Route path={`/knowledge-map`} element={<DynamicFlow />} />
      <Route path={`/create`} element={<CreateMap />} />
      <Route path='/edit/:classId' element={<CreateMap />} />
      <Route path='/create-test' element={<TestCreatorPage />} />
      <Route path='/concept-builder' element={<DoubtAssistantPage />} />
      <Route path='/concept-builder/:conversationId/:phoneNumber' element={<DoubtAssistantPage />} />
      <Route path='/performance-map' element={<PerformanceMapViewer />} />
      <Route path='/notices' element={<StudentDashboard />} />
      {/* <Route path='/question-bank' element={<QuestionBankGenerator />} /> */}
      <Route path='/question-bank' element={<QuestionBankGenerator />} /> 
       <Route path='/teacher' element={<CompleteTeacherDashboard />} /> 
      <Route path='/knowledge-map-manager' element={<KnowledgeMapManager />} />
      <Route path='/knowledge-map/:board/:class/:subject' element={<KnowledgeMapManager />} />
      
      {/* 2. Curriculum Pipeline - Transform knowledge map to syllabus */}
      <Route path='/curriculum-pipeline' element={<CurriculumPipeline />} />
      <Route path='/curriculum-pipeline/:class/:subject' element={<CurriculumPipeline />} />
      
      {/* 3. Week-Wise Study Plan - AI/Teacher generated */}
      <Route path='/week-wise-plan' element={<WeekWiseStudyPlan />} />
      <Route path='/week-wise-plan/:class/:subject' element={<WeekWiseStudyPlan />} />
      
      {/* 4. Interactive Classroom - Live teaching & learning */}
      <Route path='/interactive-classroom' element={<InteractiveClassroom />} />
      <Route path='/interactive-classroom/:class' element={<InteractiveClassroom />} />
      <Route path='/class-demo/:class/:subject/:topic' element={<InteractiveClassroom />} />
      
      {/* 5. Teacher Guidelines - Week-wise guidance */}
      <Route path='/teacher-guidelines' element={<TeacherGuidelines />} />
      <Route path='/teacher-guidelines/:class/:classType' element={<TeacherGuidelines />} />
      
      {/* 6. Student Dashboard - Student performance tracking */}
      <Route path='/student-dashboard' element={<StudentDashboardComponent />} />
      <Route path='/student-dashboard/:studentId' element={<StudentDashboardComponent />} />
      <Route path='/student/:class/:rollNo' element={<StudentDashboardComponent />} />
      
      {/* 7. Main Dashboard - Combined dashboard with all components */}
      <Route path='/platform-dashboard' element={<MainDashboard />} />
      <Route path='/dashboard' element={<MainDashboard />} />
      
      {/* Additional nested routes for specific views */}
      <Route path='/student-performance/:studentId/:class' element={<StudentDashboardComponent />} />
      <Route path='/teacher-plan/:class/:week' element={<TeacherGuidelines />} />
      <Route path='/quiz/:type/:class' element={<InteractiveClassroom />} />
      <Route path='/study-plan/:class/:subject/:week' element={<WeekWiseStudyPlan />} />
    </Routes>
  );
};
export default Performance;
